import { Attribute } from '@/models/references-classification/attribute';
import { ReferenceSkuUnitPrice } from '@/models/references/reference-sku-unit-price';
import { ReferenceSkuType } from './reference-sku-type';
import i18n from '@/plugins/i18n';

export class ReferenceSku {
    public id: number = 0;
    public referenceId: number = 0;
    public type: ReferenceSkuType = ReferenceSkuType.Ordinary;
    public isPrincipal: boolean = false;
    public code?: string;
    public price: number | null = null;
    public priceDetails?: string;
    public discountedPrice: number | null = null;
    public unitPrice?: ReferenceSkuUnitPrice;
    public position: number = 0;
    public availableUnits: number | null = null;
    public stockLevelLabel?: string;
    public attributes: Attribute[] = [];

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json, {
            unitPrice: json.unitPrice ? new ReferenceSkuUnitPrice(json.unitPrice) : undefined,
            attributes: json.attributes
                ? json.attributes.map((attr: any) => new Attribute(attr))
                    .sort((left: Attribute, right: Attribute) => {
                        return left.name!.localeCompare(right.name!, i18n.locale, { sensitivity: 'base' });
                    })
                : [],
        });
    }

    public clone(): ReferenceSku {
        const sku = new ReferenceSku();

        sku.id = this.id;
        sku.referenceId = this.referenceId;
        sku.type = this.type;
        sku.isPrincipal = this.isPrincipal;
        sku.code = this.code;
        sku.price = this.price;
        sku.priceDetails = this.priceDetails;
        sku.discountedPrice = this.discountedPrice;
        sku.unitPrice = this.unitPrice ? this.unitPrice!.clone() : undefined;
        sku.position = this.position;
        sku.availableUnits = this.availableUnits;
        sku.stockLevelLabel = this.stockLevelLabel;
        sku.attributes.push(...this.attributes.map((attr) => (new Attribute(attr)).clone()));

        return sku;
    }
}
